import React from "react";
import Footer from "../../components/Landing/Footer/Footer";
import Hero from "../../components/Landing/Hero/Hero";
import UpButton from '../../components/UpButton';
//------------------------------------------------
import SubServPart from '../../components/Landing/SubServPart' ;
import OurClients from '../../components/Landing/OurClients' ;
import Frame from '../../components/Landing/Frame'
import mill_map from '../../assets/new-banners/map.png'
import {products_last_part_2 , products_last_part_2_ar} from '../../Data/product_new' ;
//=============================================
import SubServ from '../../components/Landing/SubServ' ;
import { productsLnding , productsLnding_pacs_ris , productsLnding_polyclinic_erp} from '../../Data/products';
//============================================
import styles from "./Landing.module.scss";
import { Helmet } from "react-helmet";
import certificate_1 from '../../assets/certificates (1).jpg';
import certificate_2 from '../../assets/certificates (2).jpg';
import certificate_5 from '../../assets/certificates (5).png';
import certificate_4 from '../../assets/certificates (4).png';
//------------------------
import { LiaCertificateSolid } from "react-icons/lia";
import { Link } from "react-router-dom";
import millensys_profile from '../../assets/PDF/millensys_profile.pdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faMedal } from '@fortawesome/free-solid-svg-icons'
import { GoDotFill } from "react-icons/go";
//==
import  { useContext , useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
//==
const Landing = ({scroll , lang , page}) => {
  //==
  const { language, toggleLanguage } = useContext(LanguageContext);
  useEffect(() => {
    toggleLanguage(lang)
  }, );
  //==
  const content = {
    en: {
        sloganHighlighted : 'MILLENSYS,',
        slogan: 'Technology for a Healthier Globe',
        certification: 'certified with the multiple quality certificates e.g.',
        about : "GET TO KNOW MORE ABOUT US "
    },
    ar: {
      slogan: 'التكنولوجيا من أجل عالم أكثر صحة',
      certification : "معتمدون بعدة شهادات جودة مثل",
      about : "تعرف على المزيد عنا"
    }
  };
  let path;
  let page_products;
  if(page === 'landing'){
    page_products = productsLnding;
    path = '/landing/form'
  }else if(page === 'ar-pacs-ris'){
    page_products = productsLnding_pacs_ris;
    path = `/landing-${page}/form`
  }else if(page === 'ar-polyclinic-erp'){
    page_products = productsLnding_polyclinic_erp;
    path = `/landing-${page}/form`
  }else{
    page_products = [];
    path = '';
  }
  return (
    <div>
      <Helmet>
        <title>Millensys - Landing</title>
        {/* <script type="text/javascript">
            {`            
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "qeh6bpz9s1");
            `}
        </script> */}
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Hero lang={language} path={path}/>
        <div className={`${styles["certification_container"]} ${lang === 'ar'&&styles.ar_text}`}>
          <div className={styles["title"]}>
            <h3>
            <span>{content['en'].sloganHighlighted}</span>{content[language].slogan}
            </h3>
            <h4>
            <LiaCertificateSolid  className={styles.iconImg} /> {content[language].certification} 
          <div className={styles.certification}>
            <Link  className={styles.box}><img src={certificate_1} alt="quality certificates" loading="lazy" /></Link>
            <Link  className={styles.box}><img src={certificate_2} alt="quality certificates" loading="lazy" /></Link>
            <Link  className={styles.box}><img src={certificate_4} alt="quality certificates" loading="lazy" /></Link>
            <Link  className={styles.box}><img src={certificate_5} alt="quality certificates" loading="lazy" /></Link>
          </div>
            </h4>
            <h4>
            <FontAwesomeIcon icon={faMedal} /> | {content[language].about}
            <a href={millensys_profile} download className={styles.product_list}>
              <GoDotFill className={styles.product__list_bullet} /> MILLENSYS
            </a>
            </h4>
          </div>
        </div>
        <Frame fImg ={mill_map} lang={language}/>
        <SubServPart products={lang === 'en'? products_last_part_2 : products_last_part_2_ar} lang={language} path={path}/>
        <OurClients lang={language} />
        <SubServ products={page_products} lang={language} page={page} path={path} />
        <Footer/>
      </div>
    </div>
  );
};

export default Landing;
